import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import type { ButtonProps } from '@components/atoms';
import { Button } from '@components/atoms';

interface Props extends ButtonProps {}

export const FormButton: FC<Props> = props => {
  const { formState } = useFormContext();
  const disabled = props.disabled || (props.type === 'submit' && formState.isSubmitted && !formState.isValid);

  return <Button {...props} disabled={disabled} />;
};
